import { defineComponent as re, useSlots as oe, useTemplateRef as M, ref as C, useId as ie, computed as o, onMounted as ne, nextTick as ce, onBeforeUnmount as de, watch as P, createElementBlock as W, createCommentVNode as c, openBlock as i, createElementVNode as N, createBlock as y, resolveDynamicComponent as S, withCtx as ue, createTextVNode as ve, toDisplayString as F, toRaw as U, normalizeClass as I, createVNode as me } from "vue";
import { useSwipe as fe, useResizeObserver as pe, useMutationObserver as be } from "@vueuse/core";
import "@ds/components/Button";
import { deprecatePropNames as he } from "../../composables/usePropsDeprecation.js";
import { isIntersectionObserverAvailable as xe } from "../../utils/intersectionObserver.js";
import { tw as A } from "../../utils/tailwind.js";
import { skipFragment as Ce, isVNodeEmpty as ye } from "../../utils/vnode.js";
import { desktopCardWidths as j, mobileCardWidths as Y, cardWidths as ge, SCROLL_ANNOUNCEMENT_DELAY as ke } from "./CardCarousel.constant.js";
import _ from "./components/CardCarouselController.vue2.js";
import we from "./components/CardCarouselItems.vue2.js";
const We = ["aria-labelledby"], Te = {
  key: 0,
  class: "mb-16 inline-flex flex-row items-end gap-16 md:gap-28"
}, Ne = { class: "flex grow flex-col" }, Se = ["aria-label"], Ie = {
  key: 1,
  class: "isolate mt-8 flex"
}, Me = /* @__PURE__ */ re({
  name: "CardCarousel",
  __name: "CardCarousel",
  props: {
    center: { type: Boolean, default: !0 },
    desktopCardWidth: { default: "standard" },
    mobileCardWidth: { default: "standard" },
    prevAlternativeText: {},
    nextAlternativeText: {},
    size: { default: "small" },
    title: { default: "" },
    titleTag: { default: "h2" },
    ariaLabelledby: { default: void 0 },
    subtitle: { default: "" }
  },
  emits: ["slide-impression"],
  setup(l, { emit: q }) {
    const a = l, T = oe(), E = q, s = M("carousel-scroller"), B = M(
      "carousel-items"
    ), d = C(!1), u = C(!1), { direction: G } = fe(s, { threshold: 50 }), V = ie(), R = `${V}_title`, z = `${V}_subtitle`, m = o(() => d.value || u.value), H = o(() => [
      d.value && u.value && A`gradient-mask-lr-80`,
      d.value && !u.value && A`gradient-mask-l-90`,
      !d.value && u.value && A`gradient-mask-r-90`
    ]), L = C(""), p = o(
      () => Ce(T?.default({})).filter(
        (e) => !ye(e)
      )
    ), b = C(void 0), h = C(void 0);
    let n = null;
    const O = () => {
      const e = s.value, t = B.value?.$el;
      if (!e || !t || !xe()) {
        b.value = void 0, h.value = void 0;
        return;
      }
      n && (n.disconnect(), n = null);
      const r = /* @__PURE__ */ new Set();
      n = new IntersectionObserver(
        (k) => {
          if (k.forEach((v) => {
            const w = Array.from(t.children).indexOf(
              v.target
            );
            if (w === -1) return;
            const f = w + 1;
            v.isIntersecting && v.intersectionRatio >= 1 ? r.add(f) : r.delete(f);
          }), r.size > 0) {
            const v = Array.from(r);
            b.value = Math.min(...v), h.value = Math.max(...v);
          } else
            b.value = void 0, h.value = void 0;
        },
        {
          root: e,
          rootMargin: "0px",
          // Use threshold array to get callbacks at 0% and 100% visibility
          // This allows us to detect when items become fully visible or leave
          threshold: [0, 1]
        }
      ), Array.from(t.children).forEach((k) => {
        n?.observe(k);
      });
    }, $ = (e) => {
      const t = {
        backward: -1 * (s?.value?.clientWidth ?? 0),
        forward: s?.value?.clientWidth ?? 0
      };
      E("slide-impression", { direction: e }), s?.value?.scrollBy({
        behavior: "smooth",
        left: t[e],
        top: 0
      });
    }, J = (e, t) => {
      const r = e.getBoundingClientRect();
      return r.left >= t.left && r.right <= t.right && r.top >= t.top && r.bottom <= t.bottom;
    }, K = (e) => {
      $(e), setTimeout(() => {
        const t = s.value, r = B.value?.$el;
        if (!t || !r) return;
        const D = t.getBoundingClientRect(), w = Array.from(r.children).filter(
          (f) => J(f, D)
        ).map((f) => f.textContent?.trim()).filter(Boolean).join(", ");
        L.value = w;
      }, ke);
    }, Q = async () => {
      const e = s?.value?.scrollWidth ?? 0, t = (s?.value?.clientWidth ?? 0) + (s?.value?.scrollLeft ?? 0);
      u.value = t < e;
    }, X = () => {
      d.value = s?.value?.scrollLeft !== 0;
    }, g = () => {
      Q(), X();
    };
    ne(() => {
      g(), ce(() => {
        O();
      });
    }), de(() => {
      n && (n.disconnect(), n = null);
    }), P(G, (e) => {
      if (!e || e === "none") return;
      E("slide-impression", { direction: e === "left" ? "forward" : "backward" });
    }), P(
      p,
      () => {
        O();
      },
      { flush: "post" }
    );
    const x = o(() => T?.button?.({})?.[0] ? T.button({})[0] : null), Z = o(() => !p.value?.length), ee = o(() => a.desktopCardWidth === "narrow" ? [
      j[a.desktopCardWidth],
      Y[a.mobileCardWidth]
    ] : [
      j[a.desktopCardWidth],
      Y[a.mobileCardWidth],
      ge[a.size]
    ]), te = o(() => x.value && !m.value), le = o(() => x.value || m.value && !a.title), ae = o(() => ["hidden md:flex", a.title && "md:ml-auto"]), se = o(() => [
      a.title && "md:ml-auto",
      a.title && !m.value && "md:hidden"
    ]);
    return pe(s, () => {
      g();
    }), be(
      s,
      () => {
        g();
      },
      { attributes: !0, childList: !0, subtree: !0 }
    ), he([
      {
        reason: "Replaced by `size`, with new values `extra-small`, `small`, `medium`, `large` and `extra-large`",
        deadline: "2025-05-01",
        replacementName: "size",
        props: {
          propName: "desktopCardWidth",
          propValue: a.desktopCardWidth,
          propDefaultValue: "standard"
        }
      },
      {
        reason: "Replaced by `size`, with new values `extra-small`, `small`, `medium`, `large` and `extra-large`",
        deadline: "2025-05-01",
        replacementName: "size",
        props: {
          propName: "mobileCardWidth",
          propValue: a.mobileCardWidth,
          propDefaultValue: "standard"
        }
      }
    ]), (e, t) => Z.value ? c("", !0) : (i(), W("section", {
      key: 0,
      "aria-labelledby": `${R} ${z}`,
      "aria-roledescription": "carousel",
      class: "relative flex flex-col",
      "data-test": "card-carousel"
    }, [
      l.title ? (i(), W("div", Te, [
        N("div", Ne, [
          (i(), y(S(l.titleTag), {
            id: R,
            class: "text-static-default-hi heading-2 mb-8 md:mb-0"
          }, {
            default: ue(() => [
              ve(F(l.title), 1)
            ]),
            _: 1
          })),
          l.subtitle ? (i(), W("span", {
            key: 0,
            id: z,
            class: "text-static-default-low body-1"
          }, F(l.subtitle), 1)) : c("", !0)
        ]),
        m.value ? (i(), y(_, {
          key: 0,
          "can-scroll-next": u.value,
          "can-scroll-prev": d.value,
          "first-visible": b.value,
          "last-visible": h.value,
          "next-alternative-text": l.nextAlternativeText,
          "prev-alternative-text": l.prevAlternativeText,
          "total-items": p.value.length,
          onScroll: K
        }, null, 8, ["can-scroll-next", "can-scroll-prev", "first-visible", "last-visible", "next-alternative-text", "prev-alternative-text", "total-items"])) : c("", !0),
        te.value ? (i(), y(S(U(x.value)), {
          key: 1,
          class: I(ae.value),
          "full-width": "adaptive"
        }, null, 8, ["class"])) : c("", !0)
      ])) : c("", !0),
      N("div", {
        ref: "carousel-scroller",
        class: I(["focus-visible-outline-inset-hi rounded-sm -m-12 snap-x snap-mandatory scroll-pl-12 overflow-x-auto overscroll-x-contain scroll-smooth transition-transform duration-700 scrollbar-none", H.value]),
        onScroll: g
      }, [
        me(we, {
          ref: "carousel-items",
          "aria-labelledby": l.ariaLabelledby,
          "card-classes": ee.value,
          center: l.center ? !m.value : !1,
          class: "p-12",
          items: p.value
        }, null, 8, ["aria-labelledby", "card-classes", "center", "items"]),
        N("div", {
          "aria-label": L.value,
          "aria-live": "polite",
          class: "sr-only"
        }, null, 8, Se)
      ], 34),
      le.value ? (i(), W("div", Ie, [
        x.value ? (i(), y(S(U(x.value)), {
          key: 0,
          class: I(se.value),
          "full-width": "adaptive"
        }, null, 8, ["class"])) : c("", !0),
        m.value && !l.title ? (i(), y(_, {
          key: 1,
          "can-scroll-next": u.value,
          "can-scroll-prev": d.value,
          class: "ml-auto",
          "first-visible": b.value,
          "last-visible": h.value,
          "next-alternative-text": l.nextAlternativeText,
          "prev-alternative-text": l.prevAlternativeText,
          "total-items": p.value.length,
          onScroll: $
        }, null, 8, ["can-scroll-next", "can-scroll-prev", "first-visible", "last-visible", "next-alternative-text", "prev-alternative-text", "total-items"])) : c("", !0)
      ])) : c("", !0)
    ], 8, We));
  }
});
export {
  Me as default
};
